import { Field, SingleAndMultiSelectFieldOption } from 'module/api/field/types';
import { useGetAllSignalFieldsQuery } from 'queries/fields';
import { useMemo } from 'react';
import { UiFieldType } from './types';

export const isSelectTypeField = (fieldType: UiFieldType) =>
  fieldType === UiFieldType.SingleSelect ||
  fieldType === UiFieldType.MultiSelect;
export const reasonFieldName = 'Reason';
export const isReasonField = (field: Field) =>
  field.fieldLabel === reasonFieldName;

export const getReasonField = (fields: Field[]) =>
  fields.find((field) => isReasonField(field));
export const useGetReasonField = (): Field | undefined => {
  const { data: fields } = useGetAllSignalFieldsQuery();

  return useMemo(() => getReasonField(fields ?? []), [fields]);
};
export const getMaximumValueForOption = (
  options: SingleAndMultiSelectFieldOption[],
) => options.reduce((max, option) => Math.max(max, option.value), 0);
